import { BaseService } from "services/_baseService";
import appAxios from "services/axios";

class ChannelConnectionsAdminService extends BaseService<any> {
    constructor() {
        super(`channel-connections`);
    }
    // Отсоединить устройство от Whatsapp
    async disconnectDevice(channelConnectionID: number) {
        return appAxios.post(`/admin/orgs/${localStorage.getItem("orgID")}/channel-connections/${channelConnectionID}/disconnect-device`);
    }
    async connectTelegram(channelConnectionID: number) {
        return appAxios.post(`/admin/orgs/${localStorage.getItem("orgID")}/channel-connections/${channelConnectionID}/connect-telegram`);
    }
    async disconnectTelegram(channelConnectionID: number) {
        return appAxios.post(`/admin/orgs/${localStorage.getItem("orgID")}/channel-connections/${channelConnectionID}/disconnect-telegram`);
    }
    async connectTestSandbox(channelConnectionID: number) {
        return appAxios.post(`/admin/orgs/${localStorage.getItem("orgID")}/channel-connections/${channelConnectionID}/connect-test-sandbox`);
    }
}

export default new ChannelConnectionsAdminService();
